import { IS_APPLE } from "./environment";

export function controlOrMeta(event: KeyboardEvent): boolean {
  if (IS_APPLE) {
    return event.metaKey;
  }
  return event.ctrlKey;
}
